﻿var xhr;

webix.editors.popupWindowCombo = {
    focus: function () {
        this.getInputNode(this.node).focus();
        this.getInputNode(this.node).select();
    },
    getValue: function () {
        return this.getInputNode(this.node).value;
    },
    setValue: function (value) {
        this.getInputNode(this.node).value = value;
    },
    getInputNode: function () {
        return this.node.firstChild;
    },
    render: function () {
        return webix.html.create("div", {
            "class": "webix_dt_editor"
        }, "<input type='text' readonly>");
    }
};

webix.editors.number = {
    focus: function () {
        this.getInputNode(this.node).focus();
        this.getInputNode(this.node).select();
    },
    getValue: function () {
        return this.getInputNode(this.node).value;
    },
    setValue: function (value) {
        this.getInputNode(this.node).value = value;
    },
    getInputNode: function () {
        return this.node.firstChild;
    },
    render: function () {
        return webix.html.create("div", {
            "class": "webix_dt_editor"
        }, "<input type='number'>");
    }
};

webix.editors.startTime = {
    focus: function () {
        this.getInputNode(this.node).focus();
        this.getInputNode(this.node).select();
    },
    getValue: function () {
        return this.getInputNode(this.node).value;
    },
    setValue: function (value) {
        this.getInputNode(this.node).value = value;
    },
    getInputNode: function () {
        return this.node.firstChild;
    },
    render: function () {
        return webix.html.create("div", {
            "class": "webix_dt_editor"
        }, "<input type='text'>");
    }
};

webix.editors.stopTime = {
    focus: function () {
        this.getInputNode(this.node).focus();
        this.getInputNode(this.node).select();
    },
    getValue: function () {
        return this.getInputNode(this.node).value;
    },
    setValue: function (value) {
        this.getInputNode(this.node).value = value;
    },
    getInputNode: function () {
        return this.node.firstChild;
    },
    render: function () {
        return webix.html.create("div", {
            "class": "webix_dt_editor"
        }, "<input type='text'>");
    }
};

webix.proxy.valueLookupProxy = {
    $proxy: true,
    load: function (view, callback, requestParams) {
        var rowData = JSON.stringify(requestParams.rowData);
        if (xhr && xhr.readyState != 4) {
            xhr.abort();
        }
        xhr = $.ajax({
            dataType: "json",
            url: "/timecard/GetCellPossibleValues",
            type: 'POST',
            contentType: 'application/json',
            headers: { 'X-XSRF-Token': $('input[name="__RequestVerificationToken"]').val() },
            data: rowData,
            success: function (response) {
                var possibleValues = response.PossibleValues;
                for (var i = 0; i < possibleValues.length; i++) {
                    possibleValues[i].Value = possibleValues[i].Value.replace(/(\r\n|\n|\r)/gm, "");
                    possibleValues[i].PopUpLabel = possibleValues[i].Label.replace(/(\r\n|\n|\r)/gm, "");
                    possibleValues[i].Label = escapeHtml(possibleValues[i].Label.replace(/(\r\n|\n|\r)/gm, ""));
                }
                if (requestParams.currentCell.column == "Employee") {
                    requestParams.employeesToExclude;
                    var callcount = 0;
                    for (var i = possibleValues.length - 1; i >= 0; i--) {
                        if (requestParams.employeesToExclude.indexOf(possibleValues[i].Value) > -1) {
                            possibleValues.splice(i, 1);
                            callcount++;
                            if (callcount == requestParams.employeesToExclude.length)
                                break;
                        }
                    }
                }
                var options = [];
                for (var i = 0; i < possibleValues.length; i++) {
                    var option = {}
                    option.id = possibleValues[i].Value + "@row_" + requestParams.currentCell.row;
                    option.value = possibleValues[i].Label;
                    option.popUpLabel = possibleValues[i].PopUpLabel;
                    options.push(option);
                }
                //bind employee list if current request is for employee

                lastUsedList = options;
                view.parse(options);
                
                if (callback.length > 1) {
                    callback[1](options);
                }
                
            }
        });
    }
}

function escapeHtml(unsafe) {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

webix.ui.datafilter.summFixedColumn = webix.extend({
    refresh: function (master, node, value) {
        var result = 0;
        var num = 0;
        var expenses = 0;
        master.mapCells(null, value.columnId, null, 1, function (value, row_id) {
            var valueCopy = value;
            if ($$("crewTimecard") != null && $$("crewTimecard").getItem(row_id) != null) {
                var row = $$("crewTimecard").getItem(row_id);
                var exclude = false;
                if (row.Type != null && row.Type != "") {
                    var index = row.Type.indexOf("@");
                    var typeValue = index > -1 ? row.Type.substr(0, index) : row.Type;
                    if (typeValue == "S") {
                        if (row.SMPayType != null && row.SMPayType != "" && row.SMPayType != "null") {
                            var payType = row.SMPayType.substr(0, row.SMPayType.indexOf("@"));
                            if (amountPayTypes.indexOf(payType) > -1) {
                                exclude = true;
                            }
                        }
                    }
                    else {
                        if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
                            var earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
                            if (amountEarnCodes.indexOf(earnCode) > -1) {
                                exclude = true;
                            }
                        }
                    }

                }
                else {
                    if (row.EarnCode != null && row.EarnCode != "" && row.EarnCode != "null") {
                        var earnCode = row.EarnCode.substr(0, row.EarnCode.indexOf("@"));
                        if (amountEarnCodes.indexOf(earnCode) > -1) {
                            exclude = true;
                        }
                    }
                }
                if (!exclude) {
                    valueCopy = valueCopy * 1;
                    if (!isNaN(valueCopy))
                        result += valueCopy;

                }
                else {
                    if (!isNaN(valueCopy)) {
                        expenses += parseFloat(valueCopy);
                    }
                }
                return value;

            }
            else {
                valueCopy = value * 1;
                if (!isNaN(valueCopy))
                    result += valueCopy;
                return value;
            }
        });
        //scope.expenses = expenses;
        node.firstChild.innerHTML = result.toFixed(2);
    }
}, webix.ui.datafilter.summColumn);